import { render, staticRenderFns } from "./Dispersions.vue?vue&type=template&id=070393f0"
import script from "./Dispersions.vue?vue&type=script&lang=js"
export * from "./Dispersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports